import React, { Component } from 'react';
import { Button, Modal, Switch, message } from "antd";

class DisplaySwitch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            loading: false,
            data: {
                es: 0,
                bp: 0,
                hr: 0
            },
            switchLoading: false
        }
    }

    showModal = () => {
        this.setState({ switchLoading: true, visible: true, });
        fetch('/getTableSwitch', { credentials: 'include' }).then(x => x.json()).then(x => {
            this.setState({ data: x.data || { es: 0, bp: 0, hr: 0 }, switchLoading: false });
        }).catch(err => {
            console.error(err);
            message.error('获取失败！' + JSON.stringify(err));
            this.setState({ switchLoading: false });
        })
    }

    handleCancel = () => {
        this.setState({ visible: false });
    }

    handleOk = () => {
        let data = this.state.data;

        this.setState({ loading: true });
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: JSON.stringify(data),
        }
        fetch('/addTableSwitch', headres).then(x => x.json()).then(x => {
            this.setState({ loading: false });
            if (x.status == 1) {
                message.info('保存成功！');
                this.setState({ visible: false });
            } else {
                message.error('保存失败！' + x.msg);
            }
        }).catch(err => {
            console.error(err);
            message.error('保存失败！' + JSON.stringify(err));
            this.setState({ loading: false });
        })
    }

    render() {
        const data = this.state.data;
        return (
            <div>
                <Button
                    type="primary"
                    className="diplay-switch"
                    onClick={this.showModal}
                >
                    显示设置
                </Button>
                <Modal
                    title="表格显示设置"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button key="back" onClick={this.handleCancel}>取消</Button>,
                        <Button key="submit" type="primary" loading={this.state.loading} onClick={this.handleOk}>
                            保存
                        </Button>,
                    ]}
                >
                    <div>
                        <span style={{ marginRight: 10 }}>Executive Summary Report 月度经营报告</span>
                        <Switch
                            checkedChildren="开"
                            unCheckedChildren="关"
                            checked={data.es == 1 ? true : false}
                            loading={this.state.switchLoading}
                            onChange={checked => {
                                this.setState({
                                    data: { ...data, es: checked ? 1 : 0 }
                                });
                            }}
                        />
                    </div>
                    <div style={{ marginTop: 10 }}>
                        <span style={{ marginRight: 10 }}>Business Plan 年度经营计划</span>
                        <Switch
                            checkedChildren="开"
                            unCheckedChildren="关"
                            checked={data.bp == 1 ? true : false}
                            loading={this.state.switchLoading}
                            onChange={checked => {
                                this.setState({
                                    data: { ...data, bp: checked ? 1 : 0 }
                                });
                            }}
                        />
                    </div>
                    <div style={{ marginTop: 10 }}>
                        <span style={{ marginRight: 10 }}>Human Resources 人力资源报告</span>
                        <Switch
                            checkedChildren="开"
                            unCheckedChildren="关"
                            checked={data.hr == 1 ? true : false}
                            loading={this.state.switchLoading}
                            onChange={checked => {
                                this.setState({
                                    data: { ...data, hr: checked ? 1 : 0 }
                                });
                            }}
                        />
                    </div>
                </Modal>
            </div>
        );
    }
}

export default DisplaySwitch;


// WEBPACK FOOTER //
// ./src/components/setting/DisplaySwitch.js